<div>
	<p class="text-center font-bold">Would you like to save your changes?</p>
	<div class="w-full flex justify-between mt-4">
		<app-button btn="secondary" size="small" (click)="close(false)"
			>Continue without saving</app-button
		>
		<app-button size="small" (click)="close(true)">Save changes</app-button>
	</div>
</div>
